
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
import dayjs from "dayjs";
const service = namespace("service");
const finance = namespace("finance");
const typeMap: any = {
  "payment-customer": 1,
  "charge-more-month-order": 2
};

@Component({})
@Table("loadListData")
export default class OnAccountManage extends Vue {
  @finance.Mutation setAccountCurrentTabType;
  @finance.Action queryOnAccountCustomer;
  @finance.Action statisticOnAccount;
  @finance.Action getCustomerUnpaidOrder;
  @service.Action getOrderList;
  @finance.Mutation setOnAccountManageRow;
  @finance.State currentTabTypeAccount;
  //计算属性
  get tabBarData() {
    return [
      { tabName: t("finance.payment-customer"), type: "payment-customer" },
      { tabName: t("finance.charge-more-month-order"), type: "charge-more-month-order" }
    ];
  }
  get orderType() {
    return typeMap[this.currentTabTypeAccount];
  }
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  todayUser: any = [
    {
      name: "icon-total-money",
      title: addCurrencyUnit(t("finance.total-amount-chargeable-account"), false, true),
      tNum: undefined,
      class: "blue"
    },
    {
      name: "icon-order-quantity",
      title: t("finance.charged-order-number-pen"),
      tNum: undefined,
      class: "lime"
    },
    {
      name: "icon-one-month-all",
      title: addCurrencyUnit(t("finance.credit-over-one-month"), false, t),
      tNum: undefined,
      class: "orange"
    },
    {
      name: "icon-exceed-month",
      title: t("finance.number-orders-over-one-month"),
      tNum: undefined,
      class: "yellow"
    }
  ];
  orderList: any[] = [];
  onAccountList: any = [];
  get urlDate() {
    return this.$route.query.date || "";
  }
  created() {
    sessionStorage.setItem("onAccountId", "");
    this.getStatisticOnAccount();
    this.init();
    this.setOnAccountManageRow({});
  }

  init() {
    if (this.$route.query.type === "payment-customer") {
      this.setAccountCurrentTabType("payment-customer");
    }
    this.loadListData();
  }
  handleSwitchStatus(tab) {
    this.setAccountCurrentTabType(tab.type);
    this.mix_pageNum = 1;
    this.mix_sortParams = [{}];
    this.loadListData();
  }
  getStatisticOnAccount() {
    this.statisticOnAccount({
      timeout: dayjs().subtract(1, "month").format("YYYYMMDD")
    }).then(data => {
      this.todayUser[0].tNum = data.data?.onAccountAmount || 0;
      this.todayUser[1].tNum = data.data?.onAccountCount || 0;
      this.todayUser[2].tNum = data.data?.timeoutAmount || 0;
      this.todayUser[3].tNum = data.data?.timeoutCount || 0;
    });
  }
  queryOnAccountCustomerForm: any = {
    customerName: ""
  };
  @Table.LoadDataMethod()
  loadListData() {
    if (this.orderType === 1) {
      return this.queryOnAccountCustomer({
        ...this.queryOnAccountCustomerForm,
        orderItems: this.mix_sortParams,
        pageNum: this.mix_pageNum,
        pageSize: this.mix_pageSize
      }).then(response => {
        this.onAccountList = response.data.list;
        return response;
      });
    } else if (this.orderType === 2) {
      let sortParams = [];
      if (!this.mix_sortParams[0].item && !this.mix_sortParams[0].type) {
        sortParams[0] = {
          item: "paidTime",
          type: "asc"
        };
      } else {
        sortParams = this.mix_sortParams;
      }
      return this.getOrderList({
        orderItems: sortParams,
        paidTimeEnd: dayjs().subtract(1, "month").format("YYYYMMDD"),
        settlementStatus: "2",
        pageNum: this.mix_pageNum,
        pageSize: this.mix_pageSize,
        searchKey: this.queryOnAccountCustomerForm.customerName
      }).then(data => {
        this.orderList = data.data.list;
        return data;
      });
    }
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  async handleSettlement(row) {
    await this.getCustomerUnpaidOrder({
      customerCode: row.customerCode,
      settlementStatus: 2
    }).then(data => {
      this.$router.push({
        name: "serviceCashier",
        params: {
          id: data.data[0].orderNo,
          onAccountTo: "true",
          row: row
        }
      });
    });
  }
  handleOnAcountDetail(row) {
    sessionStorage.setItem("onAccountId", JSON.stringify(row));
    this.$router.push({
      name: "onAccountDetail",
      params: {
        customerCode: row.customerCode,
        customerName: row.customerName,
        row: row
      }
    });
  }
  handleSearchOnAccountCustomer() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  // ----------------
}
